import React from 'react';

type ThumbsUpFillIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function ThumbsUpFillIcon({
  width = '23',
  height = '22',
  color = '#6267AC',
}: ThumbsUpFillIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 21 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.3914 18.4562C19.1662 19.9197 17.907 21 16.4262 21H3C1.89543 21 1 20.1046 1 19V12C1 10.8954 1.89543 10 3 10H5.35013C5.74532 10 6.10344 9.76727 6.26394 9.40614L9.78306 1.48812C9.91498 1.1913 10.2093 1 10.5342 1C11.896 1 13 2.10399 13 3.46584V7C13 7.55228 13.4477 8 14 8H17.5032C19.3418 8 20.7479 9.6389 20.4683 11.4562L19.3914 18.4562Z'
        fill={color}
      />
      <path
        d='M6 21V10M1 12V19C1 20.1046 1.89543 21 3 21H16.4262C17.907 21 19.1662 19.9197 19.3914 18.4562L20.4683 11.4562C20.7479 9.6389 19.3418 8 17.5032 8H14C13.4477 8 13 7.55228 13 7V3.46584C13 2.10399 11.896 1 10.5342 1C10.2093 1 9.91498 1.1913 9.78306 1.48812L6.26394 9.40614C6.10344 9.76727 5.74532 10 5.35013 10H3C1.89543 10 1 10.8954 1 12Z'
        stroke='white'
        stroke-width='0.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default ThumbsUpFillIcon;
